<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content class="custom-widget-editor">
    <mat-form-field appearance="fill">
        <mat-label>Widget name</mat-label>
        <input matInput [(ngModel)]="widget.name" />
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Device</mat-label>
        <mat-select [(ngModel)]="widget.projectDeviceId" (ngModelChange)="onDeviceChange()">
            @for (device of data.devices; track device.id) {
                <mat-option [value]="device.id">{{ device.deviceName }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Primary metrics</mat-label>
        <mat-select [(ngModel)]="widget.primaryMetrics" multiple>
            @for (metric of metricOptions; track metric) {
                <mat-option [value]="metric">{{ "FIELD." + metric | translate }}</mat-option>
            }
        </mat-select>
        <mat-hint>Pick 1 to 2 metrics</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Secondary metrics</mat-label>
        <mat-select [(ngModel)]="widget.secondaryMetrics" multiple>
            @for (metric of metricOptions; track metric) {
                <mat-option [value]="metric">{{ "FIELD." + metric | translate }}</mat-option>
            }
        </mat-select>
        <mat-hint>Pick up to 4 metrics</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Chart metric</mat-label>
        <mat-select [(ngModel)]="widget.chartMetric">
            <mat-option [value]="null">None</mat-option>
            @for (metric of metricOptions; track metric) {
                <mat-option [value]="metric">{{ "FIELD." + metric | translate }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Kiosk chart behavior</mat-label>
        <mat-select [(ngModel)]="widget.fullscreenChartMode">
            @for (mode of fullscreenModes; track mode.value) {
                <mat-option [value]="mode.value">{{ mode.label }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    @if (!isValid) {
        <p class="custom-widget-editor__error">Use 1-2 primary metrics, up to 4 secondary metrics, and avoid duplicate metric choices.</p>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button class="btn-save" color="primary" type="button" [disabled]="!isValid" (click)="save()">Save</button>
</mat-dialog-actions>
